import { cachebust } from 'utils/misc'

export const getPage = async url => {
    const bustUrl = cachebust(url)

    return fetch(bustUrl, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            cache: 'no-cache',
        },
    })
}
